module.exports = __webpack_public_path__ + "languages/en_EN.json";


/*****************
 ** WEBPACK FOOTER
 ** ./languages/en_EN.json
 ** module id = 232
 ** module chunks = 1
 **/